import { ActivatedRoute } from '@angular/router';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { Component, OnInit } from '@angular/core';
import { PodVrstaDokumentaStavka } from './podvrste-dokumenta-stavka';

@Component({
  selector: 'app-podvrste-dokumenta-stavka',
  templateUrl: './podvrste-dokumenta-stavka.component.html'
})
export class PodvrsteDokumentaStavkaComponent  extends BaseModalContainer<PodVrstaDokumentaStavka> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<PodVrstaDokumentaStavka>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService

  ) {
    super(modalContainerService, activatedRoute, modalService, userService)
   }

  ngOnInit() {
  }

}
